import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";
import { stopTimer} from "../api";

import FAQList from "./pageParts/faqList"

class LIFaq extends Component {

    componentDidMount() {
        stopTimer();    
    }

    render (){
        return (
            <div>
                <Breadcrumb title={'FAQ'}/>

                <FAQList pid={'5eb35f30d619e2bbe6c86279'} /> 
                                
            </div>
        )
    }
}

export default LIFaq